// extracted by mini-css-extract-plugin
module.exports = {"app":"app","svelte-r7ueo5":"svelte-r7ueo5","wrapper":"wrapper"};